import axios from "axios";
import config from '../config'

export function getNews() {
    let url = `${config.URL}/api/news/get/3`;
    return axios.get(url)
        .then((response) => {
            return response.data.data;
        });
}